import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BettingGameTeaserComponent} from '@components/betting-game/components/betting-game-teaser/betting-game-teaser.component';



@NgModule({
  declarations: [
    BettingGameTeaserComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BettingGameTeaserComponent
  ]
})
export class LibBettingGameModule { }
